export var NotificationType;
(function (NotificationType) {
    NotificationType["ManualAlert"] = "manual-alert";
    NotificationType["SmartAlert"] = "smart-alert";
})(NotificationType || (NotificationType = {}));
//# sourceMappingURL=notification.type.js.map